// React
import { useEffect, useRef, useState } from "react";

// Router
import { useLocation, useNavigate } from "react-router-dom";

// Redux
import { useDispatch, useSelector } from "react-redux";

import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { ownerListViewAllAcc } from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import {
  beneCategories,
  beneViewAllAcc,
} from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";

// Utils
import useCustomSearchParams from "../../../utils/useCustomSearchParams";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider";
import formatDateViewAll from "../../../utils/formatDateViewAll";
import useCategories from "../../../utils/useCategories";
import { standardAccountNumberFormat } from "../../../utils/standardAccountNumberFormat";
import accountNameStandardised from "../../../utils/accountNamestandardised";

// Components
import Loader from "../../../components/Loader/Index";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent";
import PaginationComponent from "../../../components/_utils/PaginationComponent";
import CommonAssignLabelPopup from "../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import CommonToast from "../../../components/_utils/CommonToast";
import CardContainer from "../../../components/_utils/CommonViewAllCard/CardContainer";
import TextWithIcon from "../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import TextWithBank from "../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithBank";
import ListContainer from "../../../components/_utils/CommonListView/ListContainer";
import FormatAmount from "../../../components/_utils/FormatAmount/FormatAmount";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton";
import CommonBankLogo from "../../../components/_utils/CommonBankLogo";
import TickerAnimation from "../../../components/_utils/TickerAnimation";
import { toast } from "react-toastify";
import {
  addFieldForceLabelRequest,
  approveFieldForceRequest,
  getAllFieldForceRequest,
  removeFieldForceLabelRequest,
  resetToggleFfReq,
  setToggleFfReq,
} from "../../../redux/features/fieldForceRequest";
import ICONS from "../../../assets/Icons";

const parseDateRangeFromUrl = (dateStr) => {
  if (!dateStr) return { start: "", end: "" };
  const parts = dateStr.split(",");
  const start = parts[0] ? Number(parts[0]) : "";
  const end = parts[1] ? Number(parts[1]) : "";
  return { start: isNaN(start) ? "" : start, end: isNaN(end) ? "" : end };
};

const FieldForceTxnRequestViewAll = ({
  typepop,
  TxnHistoryid,
  TxnHistoryAccountName,
  categoryName,
  type,
  closeReimburseTxnDetailsModal,
  flow,
  alert,
}) => {
  const shouldBeRedacted = (price) => {
    return (
      price === "xxxx.xx" ||
      isNaN(+price) ||
      price === null ||
      price === undefined
    );
  };
  // 1️⃣ useDispatch, useNavigate, location
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // 2️⃣ useRef
  const scrollContainerRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const pageSizeChangedRef = useRef(false);

  // 3️⃣ Constants (needed for initial state)
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams } = useCustomSearchParams({
    pageno: GlobalConfiguration?.lengthCheckOne ?? 1,
    pagesize: PaginationConfiguration.paginationOptions[0],
  });
  const dateFromUrl = parseDateRangeFromUrl(searchParam.get("date"));
  const categoryMapper = useCategories();

  // 4️⃣ useState
  const [dataLoading, setDataLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState(
    type === "requestViewallPopup"
      ? dropdownOptions[0]
      : searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [currentPage, setCurrentPage] = useState(
    type === "requestViewallPopup"
      ? 1
      : Number(searchParam.get("pageno")) ||
          (GlobalConfiguration?.lengthCheckOne ?? 1),
  );

  const [pageSize, setPageSize] = useState(
    type === "requestViewallPopup"
      ? dropdownOptions[0]
      : searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [mainData, setMainData] = useState([]);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [accountnumberstate, setaccountnumberstate] = useState("");
  const [animateViewAll, setAnimateViewAll] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [requestAmountFilter, setRequestAmountFilter] = useState(
    type === "requestViewallPopup" ? "" : searchParam.get("amount") || "",
  );
  const [reimbursementAmountFilter, setReimbursementAmountFilter] = useState(
    type === "requestViewallPopup"
      ? ""
      : searchParam.get("reimbursementAmount") || "",
  );
  const [startDateFilter, setStartDateFilter] = useState(
    type === "requestViewallPopup" ? "" : dateFromUrl.start,
  );
  const [endDateFilter, setEndDateFilter] = useState(
    type === "requestViewallPopup" ? "" : dateFromUrl.end,
  );
  const [currentStatus, setCurrentStatus] = useState(
    type === "requestViewallPopup" && flow !== "RequestRejectAll"
      ? ""
      : flow === "RequestRejectAll"
        ? "pending"
        : searchParam.get("status") || "",
  );
  const [accountNumber, setAccountNumber] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [active, setActive] = useState("");
  const [currentCategory, setCurrentCategory] = useState(
    type === "requestViewallPopup" && categoryName
      ? categoryName
      : type === "requestViewallPopup"
        ? ""
        : searchParam.get("category") || (categoryName ? categoryName : ""),
  );
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [labels, setLabels] = useState([]);
  const [ownerAccId, setOwnerAccId] = useState(
    type === "requestViewallPopup" ? "" : searchParam.get("ownerAcc") || "",
  );
  const [beneAccId, setBeneAccId] = useState(
    type === "requestViewallPopup"
      ? (TxnHistoryid ?? "")
      : searchParam.get("beneAcc") || (TxnHistoryid ? TxnHistoryid : ""),
  );
  const [accountName, setAccountName] = useState(
    TxnHistoryAccountName ? TxnHistoryAccountName : "",
  );
  const [accountNameValue, setAccountNameValue] = useState("");
  const [totalBalanceAmount, setTotalBalanceAmount] = useState(0);
  const [isLabelClicked, setisLabelClicked] = useState(false);
  const [labelTransactions, setLabelTransactions] = useState([]);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [searchdata, SetsearchData] = useState(
    type === "requestViewallPopup" ? "" : searchParam.get("search") || "",
  );
  const [isPaymentMethod, setIsPaymentMethod] = useState(
    type === "requestViewallPopup"
      ? ""
      : searchParam.get("paymentmethod") || "",
  );
  const [loading, setLoading] = useState(true);

  // 5️⃣ useSelector
  const services = useSelector((state) => state.refreshToken.services);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const { toggleFfReq, storedPage } = useSelector(
    (state) => state.fieldForceRequest,
  );

  // 6️⃣ Callbacks
  const handleSubmit = (key, value) => {
    if (type !== "requestViewallPopup") {
      handleSearchParams(key, value);
    }
  };

  const handleSelect = (value) => {
    if (value !== pageSize) {
      pageSizeChangedRef.current = true;
    }
    setSelectedValue(value);
    setPageSize(value);
    const nextPage = Number(storedPage) || currentPage;
    setCurrentPage(nextPage);
    if (type !== "requestViewallPopup") {
      handleSearchParams("pagesize", value);
      handleSearchParams("pageno", nextPage);
    }
    setIsOpen(!isOpen);
  };

  const handleAction = async () => {
    setAnimateViewAll(false);
    if (searchUserTextDebounce !== "") {
      setMainData([]);
    }
    if (currentStatus === "require approval") {
      try {
        setLoading(true);

        const responseApproval = await dispatch(
          approveFieldForceRequest({
            page_no: currentPage,
            page_size: pageSize,
            category: currentCategory,
          }),
        );

        const newApprovalData = responseApproval?.payload?.requests || [];

        setMainData(responseApproval?.payload);
        setAccumulatedData(newApprovalData);
        setTotalBalanceAmount(responseApproval?.payload?.total_count || 0);
        setLoading(false);
        if (
          pageSizeChangedRef.current &&
          newApprovalData?.length &&
          isLabelClicked
        ) {
          pageSizeChangedRef.current = false;
          setLabelTransactions((prev) => {
            const idsOnPage = new Set(newApprovalData.map((r) => r.request_id));
            return prev.filter((id) => idsOnPage.has(id));
          });
        }
      } catch (error) {
        setAccumulatedData([]);
        setMainData([]);
        setLoading(false);
      }
    } else {
      try {
        setLoading(true);
        let queryParams = {
          page_no: currentPage,
          page_item_count:
            flow === "RequestRejectAll"
              ? PaginationConfiguration.paginationBig
              : pageSize,
        };

        if (currentStatus) {
          queryParams.lifecycle_status = currentStatus;
        }

        if (
          startDateFilter &&
          endDateFilter &&
          !isNaN(Number(startDateFilter)) &&
          !isNaN(Number(endDateFilter))
        ) {
          queryParams.start_date = convertDate(startDateFilter);
          queryParams.end_date = convertDate(endDateFilter);
        }

        if (ownerAccId && ownerAccId !== "") {
          queryParams.owner_account_id = [ownerAccId];
        }
        if (beneAccId && beneAccId !== "") {
          queryParams.field_force_account_id = beneAccId;
        }

        if (currentCategory) {
          queryParams.category = currentCategory;
        }

        if (requestAmountFilter) {
          queryParams.amount = requestAmountFilter;
        }
        // if (reimbursementAmountFilter) {
        //   queryParams.reimbursement_amount = reimbursementAmountFilter;
        // }

        if (searchdata !== "") {
          queryParams.additional_data = searchdata;
          // queryParams.category_name = "value";
        }

        const response = await dispatch(getAllFieldForceRequest(queryParams));
        setMainData(response?.payload);
        const newData = response?.payload?.requests || [];
        setAccumulatedData(newData);
        setLabels(response?.payload?.summary?.available_labels);
        setLoading(false);
        setTotalBalanceAmount(Number(response?.payload?.total_amount || 0));
        if (pageSizeChangedRef.current && newData?.length && isLabelClicked) {
          pageSizeChangedRef.current = false;
          setLabelTransactions((prev) => {
            const idsOnPage = new Set(newData.map((r) => r.request_id));
            return prev.filter((id) => idsOnPage.has(id));
          });
        }
      } catch (error) {
        setAccumulatedData([]);
        setMainData([]);
        setLoading(false);
        setTotalBalanceAmount(0);
      }
    }
  };

  // 7️⃣ useEffect
  useEffect(() => {
    handleAction();
  }, [
    currentPage,
    pageSize,
    currentStatus,
    isPaymentMethod,
    startDateFilter,
    endDateFilter,
    accountnumberstate,
    ownerAccId,
    beneAccId,
    searchdata,
    currentCategory,
    requestAmountFilter,
    reimbursementAmountFilter,
    markerData,
  ]);

  const convertDate = (timestampInSeconds) => {
    if (!timestampInSeconds) return "";

    const date = new Date(
      Number(timestampInSeconds) * IntervalConfiguration?.intervalMedium,
    );

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const displayDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration?.intervalMedium,
    );

    return timestamp;
  };

  const handleFilterDateRange = (date) => {
    if (date) {
      const [start, end] = date;
      const startTs = displayDate(start);
      const endTs = displayDate(end);
      setStartDateFilter(startTs);
      setEndDateFilter(endTs);
      if (type !== "requestViewallPopup") {
        handleSearchParams("date", `${startTs},${endTs}`);
      }
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
      if (type !== "requestViewallPopup") {
        handleSearchParams("date", "");
      }
    }
  };

  const onMount = () => {
    setCurrentPage(1);
    dispatch(resetToggleFfReq());
    // handleAction();
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    onMount();
    return () => {
      dispatch(disableSwitcher());
    };
  }, [markerData]);

  const handlePagination = (page) => {
    setCurrentPage(page);
    if (type !== "requestViewallPopup") {
      handleSearchParams("pageno", page);
    }
    if (isLabelClicked) {
      setLabelTransactions([]);
    }
  };

  const handlePaymentMethod = (selectedSettlement) => {
    setIsPaymentMethod(selectedSettlement);
  };

  const fetchData = async () => {
    setDataLoading(true);

    let response;
    let data = [];

    try {
      switch (active) {
        case "Category":
          response = await dispatch(
            beneCategories({ search_string: searchUserTextDebounce }),
          );
          data =
            response?.payload?.categories?.map((itm) => ({
              id: itm.name,
              Category: itm.name,
              Description: itm?.description || "Not given",
            })) || [];
          break;

        case "Field force account":
          response = await dispatch(
            beneViewAllAcc({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
              reimbursement_account: true,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.beneficiary_accounts?.map((itm) => ({
                id: itm.id,
                Name: itm.name,
                Account_number: itm.bank_acc_no,
                display: itm.name,
                IFSC_code: itm.ifsc_code,
                Contact_number: itm.contact_no,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;
        case "Search":
          if (searchUserTextDebounce === "") {
            SetsearchData("");
          } else {
            SetsearchData(searchUserTextDebounce);
          }
          setDataLoading(false);
          break;

        case "Owner account":
          response = await dispatch(
            ownerListViewAllAcc({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.owner_accounts?.map((itm) => ({
                id: itm.id,
                Account_number: itm.bank_acc_no,
                display: itm.bank_acc_no,
                Name: itm.name,
                IFSC_code: itm.ifsc_code,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;
        case "Labels":
          data = labels
            ?.filter((itm) => {
              if (itm.includes(searchUserTextDebounce)) return itm;
            })
            ?.map((val) => {
              return { id: val, Label: val, display: val };
            });
          setInputData(data);
          setDataLoading(false);
          break;

        default:
          data = [];
          break;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      data = [];
    } finally {
      setInputData([...data]);
      setDataLoading(false);
    }
  };

  useEffect(() => {
    if (active?.length) {
      fetchData();
    }
  }, [active]);

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const selectableIds = accumulatedData.map((t) => t.request_id);

  const isAllSelected =
    selectableIds.length > 0 &&
    selectableIds.every((id) => labelTransactions.includes(id));

  const handleSelectAll = () => {
    if (isAllSelected) {
      setLabelTransactions([]);
    } else {
      setLabelTransactions(selectableIds);
    }
    setisLabelClicked(true);
  };

  const handleClose = () => {
    setIsLabelPopupOpen(false);
    if (labelActionDispatchedRef.current) {
      handleAction();
      setLabelTransactions([]);
      setisLabelClicked(false);
      labelActionDispatchedRef.current = false;
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTransactions);
    const res = await dispatch(
      addFieldForceLabelRequest({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );
    if (addFieldForceLabelRequest.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await handleAction();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (addFieldForceLabelRequest.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLoading(false);
    if (addFieldForceLabelRequest?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTransactions);
    const res = await dispatch(
      removeFieldForceLabelRequest({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (removeFieldForceLabelRequest.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await handleAction();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (removeFieldForceLabelRequest.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLoading(false);
  };

  const handleToggle = (newToggleValue) => {
    if (loading) {
      setAnimateViewAll(false);
    } else {
      setAnimateViewAll(true);
    }
    if (toggleFfReq !== newToggleValue) {
      const scrollTarget = scrollContainerRef.current || window;
      scrollTarget.scrollTo({ top: 0, behavior: "smooth" });

      if (!showSearchBar) {
        dispatch(setToggleFfReq(newToggleValue));
      }

      if (type !== "requestViewallPopup") {
        handleSearchParams("pageno", GlobalConfiguration?.lengthCheckOne ?? 1);
      }
    }
  };

  const clearParameterVisibility =
    searchdata ||
    !!currentStatus ||
    !!currentCategory ||
    !!requestAmountFilter ||
    !!reimbursementAmountFilter ||
    !!accountnumberstate ||
    !!ownerAccId ||
    !!beneAccId ||
    !!searchUserTextDebounce ||
    !!(startDateFilter && endDateFilter) ||
    accumulatedData.length;

  const handleClearParams = (e) => {
    setAnimateViewAll(false);
    e?.stopPropagation();
    const defaultPage = GlobalConfiguration?.lengthCheckOne ?? 1;
    const defaultSize = dropdownOptions[0];
    setCurrentPage(defaultPage);
    setSearchUserTextDebounce("");
    // if (categoryName && type !== "requestViewallPopup") {
    //   setCurrentCategory("");
    // }
    setCurrentCategory("");
    setReimbursementAmountFilter("");
    setRequestAmountFilter("");
    setaccountnumberstate("");
    setOwnerAccId("");
    if (
      (flow !== undefined && flow !== "RequestRejectAll") ||
      type !== "requestViewallPopup"
    ) {
      setBeneAccId("");
    }
    if (flow !== "RequestRejectAll") {
      setCurrentStatus("");
    }
    setStartDateFilter("");
    setEndDateFilter("");
    setIsPaymentMethod("");
    SetsearchData("");
    if (type !== "requestViewallPopup") {
      navigate(
        {
          pathname: location.pathname,
          search: `?pageno=${defaultPage}&pagesize=${defaultSize}`,
        },
        { replace: true },
      );
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "denied":
      case "failed":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "rejected":
        return "var(--failed)";
      default:
        return "var(--settled)";
    }
  };

  return (
    <div
      id={`${type !== "requestViewallPopup" && "beneScrollContainer"} `}
      className={`bg-primary-bg ${type === "requestViewallPopup" && "h-full"} ${flow === "RequestRejectAll" && "relative"} flex flex-col webview ${
        typepop === "transactionHistorypopup" ? "h-full-height" : ""
      }`}
    >
      {accumulatedData?.length > GlobalConfiguration.lengthCheckZero && (
        <div
          className={` ${type === "requestViewallPopup" ? "absolute" : "fixed"} rounded-none ${loading && "hidden"} bg-primary-nav ${showInnerSearchBar ? "z-z-index-content pointer-events-none" : "z-z-index-dropdown"} bottom-bottom-base w-full  ${
            typepop === "transactionHistorypopup"
              ? "bottom-bottom-base w-full rounded-none Qmd:bottom-bottom-sm Qmd:w-pagination-width Qmd:rounded-b-border-radius-md"
              : "bottom-bottom-base w-full rounded-none"
          }`}
        >
          <div
            className={`${
              (type === "requestViewallPopup" || showInnerSearchBar) &&
              flow !== "RequestRejectAll" &&
              "opacity-light-opacity bg-PopUp-BackDrop h-full"
            }`}
          >
            <PaginationComponent
              handleSelect={handleSelect}
              selectedValue={selectedValue}
              data={mainData}
              pageSize={pageSize}
              dropdownOptions={dropdownOptions}
              handlePagination={handlePagination}
              currentPage={currentPage}
              setIsOpen={setIsOpen}
              typePopup={typepop === "transactionHistorypopup"}
            />
          </div>
        </div>
      )}

      {isLabelPopupOpen && (
        <div className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={labelTransactions}
            isLabelPopupOpen={isLabelPopupOpen}
            filteredData={accumulatedData
              ?.filter((r) => labelTransactions.includes(r.request_id))
              ?.map((r) => ({ ...r, id: r.request_id }))}
            onClose={handleClose}
            loading={loading}
            setLoading={setLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="viewall"
          />
        </div>
      )}
      {/* Main code start here  */}
      <div
        className={`bg-primary-bg flex ${type === "requestViewallPopup" && "relative"} flex-col  ${
          typepop === "transactionHistorypopup" ||
          type === "requestViewallPopup"
            ? "h-full"
            : "h-screen"
        }`}
        id="benetxnmain"
      >
        <div
          className={` bg-primary-nav ${type === "requestViewallPopup" ? "hidden" : "block"} Qsmd:h-navbar-breadcrumb-height flex-shrink-0`}
        ></div>
        <div
          className={`bene_div_container z-z-index-header Qmd:shadow-box-shadow-bottom Qmd:bg-primary-nav bg-primary-nav-act ${typepop === "transactionHistorypopup" || type === "requestViewallPopup" ? " w-full Qmd:w-full-popup-width" : "w-full-width"} relative `}
        >
          <TopNavComponent
            topNavHeader={totalBalanceAmount}
            topNavSubText="Total amount"
            handleBack={() => {
              if (isLabelClicked) {
                setisLabelClicked(false);
              } else {
                navigate(-1);
              }
            }}
            ispagination={
              accumulatedData?.length <= GlobalConfiguration.lengthCheckZero
                ? false
                : true
            }
            isToggleNeeded={true}
            toggleProps={{
              state: toggleFfReq,
              title: toggleFfReq ? "Grid View" : "List View",
              isDisabled: false,
              handleClick: () => {
                handleToggle(!toggleFfReq);
              },
            }}
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: loading,
              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search request",
              filterPlaceholder:
                "Name / contact number / email ID / account ID",
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: searchdata,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    SetsearchData(val);
                  },
                  isDropdown: false,
                  isDisabled: loading,
                },
                {
                  name: "Owner account",
                  short_name: "Own. Acc",
                  isMulti: false,
                  value: ownerAccId,
                  displayValue: standardAccountNumberFormat(
                    accountNumber,
                    true,
                  ),
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setOwnerAccId(val);
                    handleSubmit("ownerAcc", val);
                  },
                  setDisplayValue: setAccountNumber,
                  valueType: "string",
                  isDropdown: true,
                  isDisabled: loading ? true : false,
                },
                {
                  name: "Field force account",
                  short_name: "FF A/c",
                  isMulti: false,
                  value: beneAccId,
                  displayValue:
                    accountName?.toLowerCase() ||
                    accountNameValue?.toLowerCase(),
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setBeneAccId(val);
                    handleSubmit("beneAcc", val);
                  },
                  setDisplayValue: (val) => {
                    setAccountName(val);
                    setAccountNameValue(val);
                  },
                  isDropdown: true,
                  valueType: "string",
                  isDisabled:
                    type === "requestViewallPopup"
                      ? true
                      : loading
                        ? true
                        : false,
                },
                // {
                //   name: "24 hours transaction limit",
                //   short_name: "24 hrs limit",
                //   isMulti: false,
                //   value: reimbursementAmountFilter,
                //   setValue: (val) => {
                //     setCurrentPage(GlobalConfiguration.lengthCheckOne);
                //     setReimbursementAmountFilter(val);
                //     handleSubmit("reimbursementAmount", val);
                //   },
                //   displayValue: FormatAmount({
                //     price: reimbursementAmountFilter,
                //   }),
                //   isDropdown: false,
                //   isDisabled: loading,
                //   valueType: "number",
                // },

                // {
                //   name: "Approve amount",
                //   short_name: "Appr Amt - INR",
                //   isMulti: false,
                //   value: reimbursementAmountFilter,
                //   setValue: (val) => {
                //     setCurrentPage(GlobalConfiguration.lengthCheckOne);
                //     setReimbursementAmountFilter(val);
                //     handleSubmit("reimbursementAmount", val);
                //   },
                //   displayValue: FormatAmount({
                //     price: reimbursementAmountFilter,
                //   }),
                //   isDropdown: false,
                //   isDisabled: loading,
                //   valueType: "number",
                // },

                {
                  name: "Request amount",
                  short_name: "Req Amt - INR",
                  isMulti: false,
                  value: requestAmountFilter,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setRequestAmountFilter(val);
                    handleSubmit("requestAmount", val);
                  },
                  displayValue: FormatAmount({
                    price: requestAmountFilter,
                  }),
                  isDropdown: false,
                  isDisabled: loading,
                  valueType: "number",
                },

                {
                  name: "Category",
                  short_name: "Cat",
                  valueType: "string",
                  isMulti: false,
                  value: currentCategory,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setCurrentCategory(val);
                    handleSubmit("category", val);
                  },
                  isDropdown: true,
                  isDisabled:
                    type === "requestViewallPopup" && categoryName
                      ? true
                      : loading
                        ? true
                        : false,
                },
              ],
              filters: [
                {
                  name: "Approval status",
                  filterType: "dropdown",
                  variant: "single",
                  value: currentStatus,
                  // options: filteredStatuses.map((status) => status),
                  options: services?.includes("AFieldForceRequest")
                    ? ["require approval", "pending", "approved", "rejected"]
                    : ["pending", "approved", "rejected"],
                  dropdownPlaceHolder:
                    currentStatus === "deleted"
                      ? "Discard"
                      : currentStatus === "rejected"
                        ? "Rejected"
                        : "Select status",
                  isDisabled: flow === "RequestRejectAll" ? true : false,
                  statusPop: true,
                  handleChange: (val) => {
                    setAnimateViewAll(false);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setCurrentStatus(val);
                    handleSubmit("status", val);
                  },
                },

                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value: startDateFilter && endDateFilter,
                  isDisabled: false,
                  startDate: startDateFilter
                    ? new Date(
                        startDateFilter * IntervalConfiguration?.intervalMedium,
                      )
                    : startDateFilter,
                  endDate: endDateFilter
                    ? new Date(
                        endDateFilter * IntervalConfiguration?.intervalMedium,
                      )
                    : endDateFilter,
                  handleChange: (date) => {
                    setAnimateViewAll(false);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleFilterDateRange(date);
                  },
                },
              ],

              isFilterClearAllDisabled: !(
                (startDateFilter && endDateFilter) ||
                (flow !== "RequestRejectAll" &&
                  currentStatus?.length >
                    GlobalConfiguration.lengthCheckZero) ||
                loading
              ),

              isSearchClearAllDisabled: !(
                searchdata?.length ||
                requestAmountFilter?.length ||
                reimbursementAmountFilter?.length ||
                (type !== "requestViewallPopup" && currentCategory?.length) ||
                (type !== "requestViewallPopup" &&
                  TxnHistoryAccountName?.length) ||
                (type !== "requestViewallPopup" && beneAccId?.length) ||
                ownerAccId?.length ||
                loading
              ),

              inputData: inputData,
              active: active,
              setActive: setActive,
              loading: loading || dataLoading,
              setLoading: (e) => {},
              isShowFilter: true,
              isShowSortBy: false,
            }}
          />
        </div>
        {/* Card section  */}
        {showInnerSearchBar && (
          <div class="absolute bg-PopUp-BackDrop opacity-light-opacity pointer-events-none w-full h-full z-z-index-content Qsmd:z-z-index-header"></div>
        )}

        <div
          ref={scrollContainerRef}
          id="benetxnViewallScrollContainer"
          className={` flex-1 ${
            showInnerSearchBar
              ? "overflow-y-hidden h-screen  opacity-light-opacity bg-PopUp-BackDrop cursor-pointer-none pointer-events-none"
              : "mb-[var(--pagination-height)]"
          } ${loading && accumulatedData?.length ? "overflow-y-hidden mt-margin-md" : "overflow-y-auto"}`}
        >
          {loading ? (
            <div className="loader-container m-auto flex items-center justify-center">
              <Loader />
            </div>
          ) : accumulatedData?.length ? (
            <div
              className={` overflow-x-hidden flex-1 content-start  ${
                !toggleFfReq
                  ? "standard-card-alignment"
                  : "standard-list-view-alignment"
              } gap-x-gap-sm gap-y-gap-md`}
            >
              {!toggleFfReq
                ? accumulatedData?.map((transactions) => {
                    return (
                      // <div
                      // className={`${animateViewAll ? "animate-slide-prev" : ""}`}
                      // >

                      // </div>

                      <CardContainer
                        hoverHeight={
                          transactions?.requested_amount
                            ? GlobalConfiguration.reimbursementRequestCardHoverHeightWithAmount
                            : GlobalConfiguration?.reimbursementRequestCardHoverHeightWithoutAmount
                        }
                        filterRef={scrollContainerRef}
                        minHeight={GlobalConfiguration.BeneTxnCardMinHeight}
                        key={transactions?.request_id}
                        onClickHandler={() => {
                          const options =
                            transactions?.lifecycle_status === "pending" &&
                            services?.includes("AReimbursementRequest")
                              ? {
                                  state:
                                    currentStatus === "require approval"
                                      ? "require approval"
                                      : transactions?.lifecycle_status,
                                }
                              : {};
                          if (showInnerSearchBar) {
                            return;
                          } else {
                            if (alert === "alertpopup") {
                              CommonToast({
                                text: "Action restricted in popup mode.",
                                icon: ICONS?.ERROR_WHITE_CIRCLE,
                                variant: "var(--error)",
                                buttonNeeded: false,
                                btnProps: {
                                  enabledBgColor: "var(--primary-bg)",
                                  enabledTextColor: "var(--text-primary)",
                                  btnText: "",
                                  handleFunction: () => {},
                                  icon: "",
                                  btnType: "button",
                                  isDisabled: false,
                                  hoverOption: "white",
                                },
                              });
                            } else {
                              navigate(
                                `/field_force_transaction_dashboard/field_force_request_view_all/field_force_request_detail_page/${transactions?.request_id}`,
                                {
                                  state: {
                                    isViewAll:
                                      location.pathname.includes("view_all"),
                                    options: options,
                                  },
                                },
                              );
                            }

                            if (
                              type === "requestViewallPopup" &&
                              alert !== "alertpopup"
                            ) {
                              closeReimburseTxnDetailsModal();
                            }
                          }
                        }}
                        isDisabled={showInnerSearchBar}
                      >
                        <card-body>
                          <TextWithIcon
                            type="Amount"
                            fontWeight="semibold"
                            text={transactions?.amount}
                            subText="Request amount"
                            textColor="var(--settled)"
                          />

                          <TextWithIcon
                            text={
                              accountNameStandardised(
                                transactions?.field_force_account_name,
                              ) || "N/A"
                            }
                            type="Text"
                            subText="Account name"
                            fontWeight="normal"
                            textColor="var(--text-primary)"
                          />

                          <TextWithBank
                            text={
                              transactions?.created_on
                                ? formatDateViewAll(
                                    transactions.created_on,
                                    false,
                                    false,
                                  )
                                : "Not given"
                            }
                            subText="Created on"
                            type="Text"
                            src={categoryMapper(transactions?.category)}
                            ifscCode={
                              transactions?.field_force_account_ifsc_code
                            }
                          />
                        </card-body>

                        <card-hover>
                          <TextWithIcon
                            text={
                              currentStatus === "require approval"
                                ? "require approval"
                                : transactions?.lifecycle_status || "N/A"
                            }
                            subText={"Status"}
                            textCase={"capitalize"}
                            fontWeight={"semibold"}
                            textColor={
                              transactions?.lifecycle_status === "N/A"
                                ? "var(--text-primary)"
                                : getStatusColor(transactions?.lifecycle_status)
                            }
                          />

                          {/* {transactions?.lifecycle_status === "approved" && (
                            <TextWithIcon
                              type="Amount"
                              fontWeight="semibold"
                              text={transactions?.reimbursement_amount}
                              subText="Approve amount"
                              textColor="var(--settled)"
                            />
                          )} */}
                          {/* <TextWithIcon
                            type="Amount"
                            fontWeight="semibold"
                            text={transactions?.reimbursement_amount}
                            subText="Transaction limit"
                            textColor="var(--text-primary)"
                          /> */}
                        </card-hover>
                      </CardContainer>
                    );
                  })
                : accumulatedData?.map((transactions) => {
                    return (
                      // <div
                      // className={`${toggle && animateViewAll ? "animate-slide-next " : ""} `}
                      // >

                      // </div>

                      <ListContainer
                        hoverHeight={
                          GlobalConfiguration?.reimbursementRequestListHoverHeight
                        }
                        key={transactions?.request_id}
                        filterRef={scrollContainerRef}
                        onClickHandler={() => {
                          if (showInnerSearchBar) {
                            return;
                          } else {
                            if (alert === "alertpopup") {
                              CommonToast({
                                text: "Action restricted in popup mode.",
                                icon: ICONS?.ERROR_WHITE_CIRCLE,
                                variant: "var(--error)",
                                buttonNeeded: false,
                                btnProps: {
                                  enabledBgColor: "var(--primary-bg)",
                                  enabledTextColor: "var(--text-primary)",
                                  btnText: "",
                                  handleFunction: () => {},
                                  icon: "",
                                  btnType: "button",
                                  isDisabled: false,
                                  hoverOption: "white",
                                },
                              });
                            } else {
                              navigate(
                                `/field_force_transaction_dashboard/field_force_request_view_all/field_force_request_detail_page/${transactions?.request_id}`,
                                {
                                  state: {
                                    isViewAll:
                                      location.pathname.includes("view_all"),
                                  },
                                },
                              );
                              if (
                                type === "requestViewallPopup" &&
                                alert !== "alertpopup"
                              ) {
                                closeReimburseTxnDetailsModal();
                              }
                            }
                          }
                        }}
                      >
                        <list-body>
                          <div className="w-full flex justify-between pr-padding-sm py-padding-sm gap-x-gap-sm">
                            <div
                              className={`flex flex-col gap-y-gap-sm w-full`}
                            >
                              <div className="w-full flex gap-x-gap-sm">
                                <div className="bg-text-primary py-padding-xs flex justify-center items-center px-padding-sm rounded-r-border-radius-md">
                                  <div className="flex gap-x-gap-sm items-center">
                                    <CommonBankLogo
                                      variant="small"
                                      ifsc={
                                        transactions?.field_force_account_ifsc_code
                                      }
                                    />
                                    <div className="border-l h-[-webkit-fill-available] border-primary-bg"></div>
                                    <img
                                      className="w-icon-sm h-icon-sm"
                                      src={categoryMapper(
                                        transactions.category,
                                      )}
                                      alt="category"
                                    />
                                  </div>
                                </div>
                                <p className="overflow-hidden whitespace-nowrap overflow-ellipsis items-center text-settled text-font-xs flex-1 flex font-semibold ">
                                  <span>
                                    {(shouldBeRedacted(transactions?.amount)
                                      ? ""
                                      : "INR ") +
                                      Number(
                                        transactions?.amount,
                                      )?.toLocaleString("en-IN", {
                                        minimumFractionDigits:
                                          GlobalConfiguration.lengthCheckTwo,
                                        maximumFractionDigits:
                                          GlobalConfiguration.lengthCheckTwo,
                                      })}
                                  </span>
                                </p>
                                <div className="border-l border-primary-bg"></div>
                                <div className="flex gap-x-gap-sm justify-end items-center">
                                  <p className="text-text-primary font-normal text-font-xs min-w-standard-account-min-width  text-right">
                                    {transactions.created_on
                                      ? formatDateViewAll(
                                          transactions.created_on,
                                          false,
                                          false,
                                        )
                                      : "Not given"}
                                  </p>
                                </div>
                              </div>

                              <div className="w-full pl-padding-sm flex justify-between items-center">
                                <p
                                  className={`text-font-xs flex-1 text-text-primary truncate font-normal`}
                                >
                                  <TickerAnimation
                                    text={
                                      accountNameStandardised(
                                        transactions?.field_force_account_name,
                                      ) || "N/A"
                                    }
                                  />
                                </p>
                              </div>
                            </div>
                          </div>
                        </list-body>

                        <list-hover>
                          <div className="flex flex-col gap-y-gap-xs w-full p-padding-sm min-w-0 ">
                            <p
                              className="text-font-xs text-text-primary truncate block whitespace-nowrap overflow-hidden min-w-0 font-normal capitalize"
                              style={{
                                color:
                                  transactions?.lifecycle_status === "N/A"
                                    ? "var(--text-primary)"
                                    : getStatusColor(
                                        transactions?.lifecycle_status,
                                      ),
                                fontWeight: "bold",
                              }}
                            >
                              {currentStatus === "require approval"
                                ? "require approval"
                                : transactions?.lifecycle_status || "N/A"}
                            </p>

                            <p className="text-font-xxs text-text-secondary">
                              Status
                            </p>
                          </div>

                          {/* <div className="border-b border-primary-bg mx-margin-sm"></div> */}

                          {/* <div className="flex items-center justify-between p-padding-sm">
                            <div className="text-text-primary text-font-xs">
                              Transaction limit
                            </div>
                            <div className="text-text-primary text-font-xs">
                              {shouldBeRedacted(
                                transactions?.reimbursement_amount,
                              )
                                ? ""
                                : "INR"}{" "}
                              <FormatAmount
                                price={Number(
                                  transactions?.reimbursement_amount,
                                )}
                              />
                            </div>
                          </div> */}
                        </list-hover>
                      </ListContainer>
                    );
                  })}
            </div>
          ) : (
            // </div>
            <div
              className={`flex flex-col items-center justify-center m-auto  Qsmd:mt-margin-base mt-margin-md h-screen `}
            >
              <div className="flex flex-col gap-gap-sm items-center justify-center">
                <img
                  src="https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                  alt="No accounts found"
                  className="w-graphic-width-md h-graphic-rectangle-height-md"
                />
                <p className="text-text-primary text-font-sm font-normal">
                  No data found.
                </p>
                {clearParameterVisibility ? (
                  <div>
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={handleClearParams}
                      enabledTextColor="var(--text-primary)"
                    />
                  </div>
                ) : null}
              </div>

              {isLabelClicked ? (
                <div
                  className={`h-navbar-breadcrumb-height mb-margin-xl block Qmd:hidden ${
                    typepop === "RejectAllTransactionPopup" &&
                    "mb-margin-bottom-pop-up"
                  }`}
                ></div>
              ) : null}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FieldForceTxnRequestViewAll;
